<template>
    <tile class="min-h-[185px] h-[185px] max-w-[300px] min-w-[300px] tile-overwrite" :paddingAmount="1" :showBorder="quantity > 0">
        <template v-slot:content>
            <div v-if="imageSource" class="wide-image">
                <img class="product-image" :src="imageSource">
            </div>
            <div class="ml-[11px] relative">
                <div class="text-left product-info-container">
                    <div>
                        <h5 class="product-name">{{productName}}</h5>
                        <span class="sku-text">{{skuText.replace('-BUNDLE', '')}}</span>
                        <div
                            v-if="skuText.includes('1226')"
                            >
                        <svg
                            class="inline mr-1/4 relative cursor-pointer"
                            :class='cursor-pointer'
                            v-on="{
                                    mouseenter: () => (open = !open),
                                    mouseleave: () => (open = !open),
                                }
                            "
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                            d="M9.16663 14.1667H10.8333V9.16675H9.16663V14.1667ZM9.99996 1.66675C5.39996 1.66675 1.66663 5.40008 1.66663 10.0001C1.66663 14.6001 5.39996 18.3334 9.99996 18.3334C14.6 18.3334 18.3333 14.6001 18.3333 10.0001C18.3333 5.40008 14.6 1.66675 9.99996 1.66675ZM9.99996 16.6667C6.32496 16.6667 3.33329 13.6751 3.33329 10.0001C3.33329 6.32508 6.32496 3.33341 9.99996 3.33341C13.675 3.33341 16.6666 6.32508 16.6666 10.0001C16.6666 13.6751 13.675 16.6667 9.99996 16.6667ZM9.16663 7.50008H10.8333V5.83342H9.16663V7.50008Z"
                            fill="#00263E"
                            />
                        </svg>
                        <Tooltip
                            v-show="open === true"
                            :content="twelveTwentySixDisclaimer"
                        />
                        </div>
                    </div>
                </div>
                <div class="quantity-info-container">
                    <CableQuantityToggle
                        ref="selectedQuantity"
                        :max="maxPurchasableQuantity"
                        :min="minPurchasableQuantity"
                        :default="startingNumber"
                        :maxedOut="maxedOut"
                        @setProductQuantity="setQuantity"
                    />
                </div>
            </div>
        </template>
    </tile>
</template>

<script>
import Tile from '../../utils/tile';
import Tooltip from "./components/Tooltip.vue";
import CableQuantityToggle from '../../utils/cable-quantity-toggle';
import { mapGetters } from "vuex";

export default {
    components: {Tile, Tooltip, CableQuantityToggle},

    props: {
        imageSource: {
            type: String
        },
        productName: {
            type: String
        },
        skuText: {
            type:String
        },
        maxPurchasableQuantity: {
            type: Number
        },
        minPurchasableQuantity: {
            type: Number,
            default: 0
        },
        startingNumber: {
            type: Number,
            default: 0
        },
        maxedOut: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            quantity: this.startingNumber,
            open: false,
            twelveTwentySixDisclaimer: "Please note: we recommend that RP1226 cables are not swapped for other cables for vehicles 2019+ to ensure network health and manufacture warranty.",
        }
    },

    computed:{
        ...mapGetters([
            "productCatalog",
            "activeProductKey",
            "activeOfferKey",
            "activeOffer",
            "displayVehicleCableSelectionOptions",
        ]),
    },

    methods: {
        setQuantity(selectedQuantity) {
            this.quantity = selectedQuantity;
        },
    }


}
</script>

<style scoped>
    .product-name {
        font-weight: bold;
        font-size: 18px;
        line-height: 19px;
        color: #2E3438;
        text-transform: none;
        margin-bottom: 0px;
    }

    .product-image {
        max-width: 140px;
        width: 100%;
    }

    .sku-text {
        font-size: 14px;
        line-height: 20px;
    }

    .flex {
        display: flex;
    }

    .product-info-container {
        align-items: center;
        justify-content: flex-start;
        max-width: 180px;
        margin-top: 20px;
    }

    .quantity-info-container {
        align-items: center;
        justify-content: flex-end;
        margin-top: 10px;
        margin-bottom: 10px;
        position: absolute;
        left: 0;
        bottom: 0;
    }

    .wide-image {
        min-width: 30%;
        min-height: 100% !important;
        display: flex;
        align-items: center;
    }

    .wide-image img {
        width: 100px;
    }

    .tile-overwrite {
        margin-top: 0 !important;
        margin-bottom: 20px !important;
        padding-left: 0;
        padding-right: 0;
    }

    @media only screen and (max-width: 735px) {
        .product-info-container {
            align-items: center;
            justify-content: center;
        }

        .quantity-info-container {
            align-items: center;
            justify-content: center;
        }

        .tile-overwrite {
            margin-top: 0 !important;
            margin-bottom: 20px !important;
        }
    }

</style>
